import { ROUTE_NAMES } from '@/lib/enums';

export const routes = [
	{
		path: '',
		name: ROUTE_NAMES.MANTLE.OVERVIEW,
		component: () => {
			return import('@/views/mantle/Overview.vue');
		},
		meta: {
			requireAuth: true,
			title: 'Mantle - Overview',
		},
	},
];
